import { useState } from 'react';
import { Button, Checkbox, Group, Modal, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import type { TableExportOptions } from '../utility/tableExcelExport';

type TableExcelExportModalProps = {
  opened: boolean;
  onClose: () => void;
  onExport: (options: TableExportOptions) => void;
  showIncludeIds?: boolean;
  showIncludeDeletedColumn?: boolean;
};

export function TableExcelExportModal({
  opened,
  onClose,
  onExport,
  showIncludeIds = true,
  showIncludeDeletedColumn = true,
}: TableExcelExportModalProps) {
  const { t } = useTranslation();
  const [includeIds, setIncludeIds] = useState(false);
  const [includeDeletedColumn, setIncludeDeletedColumn] = useState(false);

  const resetAndClose = () => {
    setIncludeIds(false);
    setIncludeDeletedColumn(false);
    onClose();
  };

  const handleExport = () => {
    onExport({
      includeIds: showIncludeIds ? includeIds : false,
      includeDeletedColumn: showIncludeDeletedColumn ? includeDeletedColumn : false,
    });
    setIncludeIds(false);
    setIncludeDeletedColumn(false);
  };

  return (
    <Modal
      opened={opened}
      onClose={resetAndClose}
      title={t('common.export.title')}
      centered
    >
      <Stack spacing="md">
        <Text size="sm">{t('common.export.description')}</Text>
        {showIncludeIds ? (
          <Checkbox
            label={t('common.export.includeIds')}
            checked={includeIds}
            onChange={(event) => setIncludeIds(event.currentTarget.checked)}
          />
        ) : null}
        {showIncludeDeletedColumn ? (
          <Checkbox
            label={t('common.export.includeDeletedColumn')}
            checked={includeDeletedColumn}
            onChange={(event) => setIncludeDeletedColumn(event.currentTarget.checked)}
          />
        ) : null}
        <Group position="right">
          <Button variant="default" onClick={resetAndClose}>
            {t('common.cancel')}
          </Button>
          <Button size="xs" color="green" onClick={handleExport}>
            {t('common.export.excel')}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
